import { AdminMembersPage } from '@features/admin/components/AdminMembersPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/_shell/admin/members')({ component: AdminMembersPage });
